import React from 'react';
import AdminLayout from '../../components/templates/layout/AdminLayout';
import UserManagement from '../../components/templates/admin/UserManagement/UserManagement';

const UserManagementPage = () => {
  return (
    <AdminLayout>
      <UserManagement />
    </AdminLayout>
  );
};

export default UserManagementPage;
